var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1418 8.17893C20.539 7.50905 21.1037 6.9541 21.7804 6.56863C22.4571 6.18317 23.2225 5.98047 24.0013 5.98047C24.7801 5.98047 25.5455 6.18317 26.2222 6.56863C26.8989 6.9541 27.4636 7.50905 27.8608 8.17893L43.9148 35.2529C44.3184 35.9337 44.5346 36.7091 44.5414 37.5005C44.5482 38.2919 44.3453 39.071 43.9534 39.7585C43.5615 40.4461 42.9945 41.0176 42.3101 41.415C41.6256 41.8124 40.8482 42.0214 40.0568 42.0209H7.94379C7.15238 42.0214 6.37494 41.8124 5.69053 41.415C5.00611 41.0176 4.43911 40.4461 4.04718 39.7585C3.65526 39.071 3.45237 38.2919 3.45915 37.5005C3.46593 36.7091 3.68214 35.9337 4.08579 35.2529L20.1418 8.17893Z",
    fill: "#D0D0D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0408 15.1191H22.5078V30.0661H25.0408V15.1191Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0408 34.043H22.5078V37.032H25.0408V34.043Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/Icon Warning.4884b387.svg";
export { ForwardRef as ReactComponent };